import { render, staticRenderFns } from "./RulesRegulationsUp.vue?vue&type=template&id=30415467&scoped=true"
import script from "./RulesRegulationsUp.vue?vue&type=script&lang=js"
export * from "./RulesRegulationsUp.vue?vue&type=script&lang=js"
import style0 from "./RulesRegulationsUp.vue?vue&type=style&index=0&id=30415467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30415467",
  null
  
)

export default component.exports